import Cookies from "js-cookie";

let _domain: string | undefined;

function getDomain() {
  if (_domain) {
    return _domain;
  }

  if (typeof window !== "undefined") {
    const tokens = window.location.hostname.split(".");
    if (window.location.hostname === "localhost") {
      _domain = window.location.hostname;
    } else if (tokens.length < 2) {
      _domain = "." + window.location.hostname;
    } else {
      _domain =
        "." + tokens[tokens.length - 2] + "." + tokens[tokens.length - 1];
    }
  }

  return _domain;
}

export const CookieService = {
  get(key: string) {
    return Cookies.get(key);
  },
  set(key: string, value: string) {
    Cookies.set(key, value, {
      domain: getDomain(),
    });
  },
  remove(key: string) {
    Cookies.remove(key, {
      domain: getDomain(),
    });
  },
};
